
import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { FunctionComponent as F } from 'react';
import Button from '../UI/Button/Button';
import { trimTrailing0s } from '../../utils/string';


interface IProps
{
  close: () => void;
  dosings: {
    productName?: string,
    dose: number,
    doseUnit: string,
    recDose?: number,
    recDoseUnit?: string,
    amountUnit?: string,
    firstOptionUnit: string }[]
}

const InvalidDosesDialog: F<IProps> = (props: IProps) =>
{
  const dosings = props.dosings;

  if(!dosings.length)
    return <></>;

  const replacementDoseText = (dosing: {
    recDose?: number,
    recDoseUnit?: string,
    amountUnit?: string,
    firstOptionUnit: string }) =>
  {
    if(dosing.recDose && dosing.recDoseUnit)
      return trimTrailing0s(dosing.recDose) + " " + dosing.recDoseUnit + " (the recommended dose)";
    else if(dosing.amountUnit)
      return "1 " + dosing.amountUnit + " (1 amount unit)";
    else
      return "1 " + dosing.firstOptionUnit;
  }


  return(
    <Dialog
      maxWidth='md'
      PaperProps={{ sx: { p: '15px' }}}
      open={true}
      onClose={props.close}>
      <DialogTitle sx={{ fontSize: '30px' }}>Replaced doses</DialogTitle>
      <DialogContent>

        <Typography variant='body2' key={'text0'} gutterBottom>
          {props.dosings.length > 1 ?
            ("Unable to convert the assigned dose units for multiple rows to one of the available units for each product.") :
            ("Unable to convert the assigned dose unit " + (dosings[0].productName ? "of " + dosings[0].productName + " " : "") +
            "to one of the available units for this product.")}
        </Typography>

        <Box sx={{ height: 4 }}/>

        {props.dosings.length > 1 ?
          <>
            <Typography variant='body2' gutterBottom>
              {"The doses will be replaced with: "}
            </Typography>
            {dosings.map((d, i) =>
            {
              return (
                <Box key={i}>
                  <Typography variant='body2' gutterBottom>
                    {d.productName + ": " +
                      trimTrailing0s(d.dose) + " " + d.doseUnit + " -> " +
                      replacementDoseText(d) + "."}
                  </Typography>
                </Box>);
            })}
          </> :
          <Typography variant='body2' gutterBottom>
            {"The dose " + trimTrailing0s(dosings[0].dose) + " " + dosings[0].doseUnit + " will be replaced with " +
            replacementDoseText(dosings[0])}
          </Typography>}

        <Box sx={{ height: 24 }}/>

        <Button onClick={props.close} label='Ok'/>
      </DialogContent>
    </Dialog>);
}

export default InvalidDosesDialog